export const motivationalPhrases = [
  "💪 Cada pequeno passo hoje é um grande salto rumo à sua independência financeira!",
  "🚀 Seus sonhos financeiros estão mais próximos do que você imagina!",
  "⭐ O sucesso é a soma de pequenos esforços repetidos dia após dia.",
  "🎯 Foque no progresso, não na perfeição. Você está no caminho certo!",
  "💎 Sua disciplina financeira de hoje é o seu tesouro de amanhã.",
  "🌟 Grandes conquistas começam com pequenas decisões inteligentes.",
  "🔥 Você tem o poder de transformar sua realidade financeira!",
  "🏆 Cada meta alcançada é prova do seu potencial ilimitado.",
  "💡 Investir em conhecimento sempre traz os melhores juros.",
  "🌱 Plante hoje as sementes do seu futuro próspero.",
  "⚡ Sua determinação é mais forte que qualquer obstáculo financeiro.",
  "🎪 O circo da vida financeira exige equilíbrio, mas você é o artista principal!",
  "🗝️ Você já tem a chave do sucesso: disciplina e planejamento.",
  "🌈 Depois da tempestade financeira, sempre vem o arco-íris da prosperidade.",
  "🧭 Seu planejamento financeiro é a bússola que te guia ao sucesso.",
  "🎨 Você é o artista da sua própria história de sucesso financeiro.",
  "🔋 Sua energia positiva é o combustível para alcançar seus objetivos!",
  "🎁 Cada dia é uma nova oportunidade de melhorar sua situação financeira.",
  "🌊 Seja como a água: persistente, flexível e sempre encontrando um caminho.",
  "🎪 A vida financeira é um espetáculo, e você é a estrela principal!",
  "💰 Pequenas economias hoje são grandes riquezas amanhã!",
  "📈 Seu patrimônio cresce a cada decisão financeira inteligente!",
  "🏦 Construa seu futuro financeiro tijolo por tijolo!",
  "📊 Números não mentem: sua dedicação está dando resultados!",
  "💸 Controle seus gastos e liberte sua liberdade financeira!",
  "🎪 A riqueza é um jogo de paciência e estratégia!",
  "🏆 Você é o CEO da sua própria empresa financeira!",
  "💳 Cada conta paga é uma vitória conquistada!",
  "📉 Reduza dívidas, aumente oportunidades!",
  "💼 Seu trabalho duro hoje é seu conforto amanhã!",
  "🎯 Tenha metas claras e conquiste sua abundância!",
  "🌟 Brilhe na sua jornada financeira!",
  "🔥 Queime gordura financeira com fogo na barriga!",
  "⚡ Sua energia financeira está carregada para o sucesso!",
  "🏔️ Escalone o monte da prosperidade passo a passo!",
  "🧭 Navegue pelas águas da riqueza com sabedoria!",
  "🎨 Pinte seu futuro com cores de abundância!",
  "🌱 Cultive hábitos financeiros saudáveis!",
  "🗝️ Abra as portas da prosperidade com educação financeira!",
  "🎪 O show da riqueza está prestes a começar!",
  "💪 Levante pesos financeiros e construa músculos de sucesso!",
  "🚀 Lance-se para a órbita da independência financeira!",
  "⭐ Seja a estrela do seu próprio filme de sucesso!",
  "🎯 Acerte no alvo das suas metas financeiras!",
  "💎 Pola suas finanças com diamantes de sabedoria!",
  "🌟 Ilumine seu caminho com luzes de prosperidade!",
  "🔥 Incendeie sua motivação financeira!",
  "🏆 Levante troféus de conquistas financeiras!",
  "💡 Ilumine sua mente com conhecimento financeiro!",
  "🌱 Germine sementes de riqueza duradoura!",
  "⚡ Acelere seu caminho para a abundância!",
  "🎪 Entre no palco da prosperidade financeira!",
  "🗝️ Desbloqueie o cofre da sua liberdade financeira!",
  "🌈 Crie arco-íris de oportunidades financeiras!",
  "🧭 Oriente-se para o norte da riqueza!",
  "🎨 Desenhe seu mapa da abundância!",
  "🔋 Recarregue suas baterias de motivação!",
  "🎁 Desembrulhe presentes de oportunidades!",
  "🌊 Navegue pelas correntezas da prosperidade!",
  "💰 Conte seu dinheiro com alegria e gratidão!",
  "📈 Assista seus gráficos financeiros subirem!",
  "🏦 Construa fortalezas de segurança financeira!",
  "📊 Analise seus dados e celebre seus avanços!",
  "💸 Liberte-se das algemas das dívidas!",
  "🎪 Entre no circo da riqueza com entusiasmo!",
  "🏆 Conquiste medalhas de ouro financeiro!",
  "💳 Pague suas contas com orgulho e satisfação!",
  "📉 Observe suas dívidas desaparecerem no horizonte!",
  "💼 Construa seu império financeiro pedra por pedra!",
  "🎯 Alcance suas metas com precisão cirúrgica!",
  "🌟 Brilhe como uma supernova da prosperidade!",
  "🔥 Queime etapas rumo à independência financeira!",
  "⚡ Acelere sua jornada para a riqueza!",
  "🏔️ Conquiste picos de sucesso financeiro!",
  "🧭 Use sua bússola interna para a abundância!",
  "🎨 Crie obras-primas de planejamento financeiro!",
  "🌱 Cultive jardins de oportunidades!",
  "🗝️ Abra fechaduras de possibilidades infinitas!",
  "🎪 Seja o mestre de cerimônias da sua riqueza!",
  "💪 Construa impérios com força de vontade!",
  "🚀 Propulse-se para novos patamares!",
  "⭐ Seja o protagonista da sua história de sucesso!",
  "🎯 Acerte em cheio nos seus objetivos!",
  "💎 Descubra tesouros escondidos de sabedoria!",
  "🌟 Ilumine caminhos escuros com sua luz!",
  "🔥 Inflame paixões por crescimento financeiro!",
  "🏆 Colecione vitórias como troféus preciosos!",
  "💡 Invente soluções brilhantes para desafios!",
  "🌱 Plante raízes profundas de segurança!",
  "⚡ Gere energia positiva para conquistas!",
  "🎪 Transforme sua vida em um espetáculo!",
  "🗝️ Descubra chaves para portas douradas!",
  "🌈 Crie pontes arco-íris para a prosperidade!",
  "🧭 Mantenha o curso certo para o sucesso!",
  "🎨 Desenhe futuros brilhantes e promissores!",
  "🔋 Mantenha-se carregado de motivação!",
  "🎁 Receba bênçãos de oportunidades diárias!",
  "🌊 Surfe nas ondas da abundância!",
  "💰 Construa fortunas com paciência e persistência!",
  "📈 Observe gráficos ascendentes com satisfação!",
  "🏦 Crie bancos pessoais de segurança!",
  "📊 Use dados para guiar suas decisões!",
  "💸 Corte gastos desnecessários com alegria!",
  "🎪 Entre no ringue da prosperidade!",
  "🏆 Ganhe corridas financeiras com estratégia!",
  "💳 Gerencie seu dinheiro com maestria!",
  "📉 Reduza riscos e aumente ganhos!",
  "💼 Construa carreiras sólidas e rentáveis!",
  "🎯 Mire no alvo da independência financeira!",
  "🌟 Seja farol de inspiração para outros!",
  "🔥 Mantenha o fogo da motivação aceso!",
  "⚡ Gere momentum para grandes conquistas!",
  "🏔️ Supere barreiras e conquiste cumes!",
  "🧭 Mantenha-se orientado para o norte magnético!",
  "🎨 Crie arte com suas estratégias financeiras!",
  "🌱 Cultive relacionamentos produtivos!",
  "🗝️ Abra portas para oportunidades ilimitadas!",
  "🎪 Seja diretor do filme da sua vida!",
  "💪 Desenvolva força interior para desafios!",
  "🚀 Lance-se em jornadas extraordinárias!",
  "⭐ Seja estrela guia da sua própria constelação!",
  "🎯 Pratique tiro ao alvo com suas metas!",
  "💎 Descubra gemas preciosas de conhecimento!"
];

export const getRandomMotivationalPhrase = (): string => {
  const randomIndex = Math.floor(Math.random() * motivationalPhrases.length);
  return motivationalPhrases[randomIndex];
};
